//
//
//
//
//
//
//
//
//
//
//
//

import LayoutSeoDefaults from '@/mixins/LayoutSeoDefaults'
import LayoutInit from '@/mixins/LayoutInit'
import LayoutWrapper from '@/components/layout/LayoutWrapper'

// noinspection JSUnusedGlobalSymbols
export default {
  name: 'ProfileLayout',
  components: {
    LayoutWrapper
  },
  mixins: [LayoutSeoDefaults, LayoutInit]
}
